/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

const getUserType = require('od-modules/helpers/membership/get_user_type');
const addMembership = require('od-modules/helpers/membership/add_membership');
const setPriceSelected = require('od-modules/helpers/membership/set_price_selected');
const disableAutoRenewal = require('od-modules/helpers/membership/disable_auto_renewal');
const enableAutoRenewal = require('od-modules/helpers/membership/enable_auto_renewal');
const getSubscriptionDetails = require('od-modules/helpers/membership/get_subscription_details');
const isRenewalAtFirstBooking = require('od-modules/helpers/membership/is_renewal_at_first_booking');
const getRenewalStatus = require('od-modules/helpers/membership/get_renewal_status');
const getTokenInfo = require('od-modules/helpers/membership/get_token_info');

function bindFncOrConstant(fnc, ctx) {
    return Odigeo._.isFunction(fnc) ? Odigeo._.bind(fnc, ctx) : Odigeo._.constant(null);
}

module.exports = Odigeo.Model.extend({
    defaults: {
        data: null,
    },

    currentAction: null,

    init: function() {},

    url: function() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')(this.currentAction.getUrl());
    },

    getDataRequestSettings: function() {
        return {
            data: this.get('data'),
            dataType: 'json',
            contentType: 'application/json',
            type: this.currentAction.getMethod(),
            success: bindFncOrConstant(this.currentAction.requestSuccess, this),
            error: bindFncOrConstant(this.currentAction.requestError, this),
            complete: bindFncOrConstant(this.currentAction.requestComplete, this),
        };
    },

    addMembership: function(request) {
        if (addMembership.hasToPerformRequest(request)) {
            const formatRequest = addMembership.formatData(request);
            this.set('data', formatRequest);
            this.set('request', request);
            this.currentAction = addMembership;
            this.performRequest();
        } else {
            Odigeo.trigger('continueTransitionToPayment');
        }
    },

    getUserType: function(email) {
        this.set('data', email);
        this.currentAction = getUserType;
        this.performRequest();
    },

    setPriceSelected: function(isPriceWithoutDiscountSelected) {
        this.set('data', JSON.stringify({priceWithoutDiscountSelected: isPriceWithoutDiscountSelected}));
        this.currentAction = setPriceSelected;
        this.performRequest();
    },

    enableAutoRenewal: function() {
        this.currentAction = enableAutoRenewal;
        this.performRequest();
    },

    disableAutoRenewal: function() {
        this.currentAction = disableAutoRenewal;
        this.performRequest();
    },

    getSubscriptionDetails: function() {
        this.currentAction = getSubscriptionDetails;
        this.performRequest();
    },

    isRenewalAtFirstBooking() {
        this.currentAction = isRenewalAtFirstBooking;
        this.performRequest();
    },

    getRenewalStatus() {
        this.currentAction = getRenewalStatus;
        this.performRequest();
    },

    getMembership() {
        this.currentAction = {
            getUrl: Odigeo._.constant('getmembershipstatus'),
            getMethod: Odigeo._.constant('GET'),
            requestSuccess(data) {
                Odigeo.trigger(`${this.widget.id}:getMembershipOk`, data);
            },
            requestError(error) {
                Odigeo.trigger(`${this.widget.id}:getMembershipFail`, error);
            },
        };
        this.performRequest();
    },

    getTokenInfo(token) {
        this.set('data', token);
        this.currentAction = getTokenInfo;
        this.performRequest();
    },

    performRequest: function() {
        this.isEmptyData = false;
        this.refresh();
    },
});
